require('../../modules/es7.object.get-own-property-descriptors');
module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/get-own-property-descriptors.js
// module id = 214
// module chunks = 0 1